/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetEvBatteryManufacturerResponse } from '../models/ApiResponseGetEvBatteryManufacturerResponse';
import type { ApiResponseGetEvBatteryStatusResponse } from '../models/ApiResponseGetEvBatteryStatusResponse';
import type { ApiResponseGetEvChargeHistoryResponse } from '../models/ApiResponseGetEvChargeHistoryResponse';
import type { ApiResponseGetEvChargeSummaryResponse } from '../models/ApiResponseGetEvChargeSummaryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EvBatteryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 배터리 상태 조회
   * 배터리 상태 조회 (SoC, SoH, 마지막 충전 날짜)
   * @returns ApiResponseGetEvBatteryStatusResponse OK
   * @throws ApiError
   */
  public getEvBatteryStatus({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetEvBatteryStatusResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/status',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 배터리 제조사 조회
   * 배터리 제조사 조회 (EU는 항상 UNKNOWN 반환)
   * @returns ApiResponseGetEvBatteryManufacturerResponse OK
   * @throws ApiError
   */
  public getEvBatteryManufacturer({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManufacturerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/manufacturer',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 충전 습관 통계 조회
   * 90일 충전 습관 통계 조회
   * @returns ApiResponseGetEvChargeSummaryResponse OK
   * @throws ApiError
   */
  public getEvChargeSummary({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetEvChargeSummaryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/charge/summary',
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 충전 이력 조회
   * 최근 90일간 충전 이력 조회
   * @returns ApiResponseGetEvChargeHistoryResponse OK
   * @throws ApiError
   */
  public getEvChargeHistory({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetEvChargeHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/charge/history',
      query: {
        'vin': vin,
      },
    });
  }
}
